var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSchoolRepresentative = function SvgSchoolRepresentative(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666656 14.6666H15.3333",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1867 14.6733V11.7",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 7.26001C12.3866 7.26001 11.7333 7.91335 11.7333 8.72668V10.24C11.7333 11.0533 12.3866 11.7067 13.2 11.7067C14.0133 11.7067 14.6667 11.0533 14.6667 10.24V8.72668C14.6667 7.91335 14.0133 7.26001 13.2 7.26001Z",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39999 14.6667V4.02006C1.39999 2.68006 2.06669 2.00671 3.39336 2.00671H7.54668C8.87335 2.00671 9.53334 2.68006 9.53334 4.02006V14.6667",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86667 5.5H7.16668",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86667 8H7.16668",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.6666V12.1666",
    stroke: "#888EA7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSchoolRepresentative);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNjY2NjU2IDE0LjY2NjZIMTUuMzMzMyIgc3Ryb2tlPSIjODg4RUE3IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy4xODY3IDE0LjY3MzNWMTEuNyIgc3Ryb2tlPSIjODg4RUE3IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy4yIDcuMjYwMDFDMTIuMzg2NiA3LjI2MDAxIDExLjczMzMgNy45MTMzNSAxMS43MzMzIDguNzI2NjhWMTAuMjRDMTEuNzMzMyAxMS4wNTMzIDEyLjM4NjYgMTEuNzA2NyAxMy4yIDExLjcwNjdDMTQuMDEzMyAxMS43MDY3IDE0LjY2NjcgMTEuMDUzMyAxNC42NjY3IDEwLjI0VjguNzI2NjhDMTQuNjY2NyA3LjkxMzM1IDE0LjAxMzMgNy4yNjAwMSAxMy4yIDcuMjYwMDFaIiBzdHJva2U9IiM4ODhFQTciIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEuMzk5OTkgMTQuNjY2N1Y0LjAyMDA2QzEuMzk5OTkgMi42ODAwNiAyLjA2NjY5IDIuMDA2NzEgMy4zOTMzNiAyLjAwNjcxSDcuNTQ2NjhDOC44NzMzNSAyLjAwNjcxIDkuNTMzMzQgMi42ODAwNiA5LjUzMzM0IDQuMDIwMDZWMTQuNjY2NyIgc3Ryb2tlPSIjODg4RUE3IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zLjg2NjY3IDUuNUg3LjE2NjY4IiBzdHJva2U9IiM4ODhFQTciIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMuODY2NjcgOEg3LjE2NjY4IiBzdHJva2U9IiM4ODhFQTciIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuNSAxNC42NjY2VjEyLjE2NjYiIHN0cm9rZT0iIzg4OEVBNyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";